var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(-939 -384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(939 384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M20,40A20,20,0,0,1,5.858,5.858,20,20,0,1,1,34.142,34.142,19.869,19.869,0,0,1,20,40ZM20,2A18,18,0,1,0,38,20,18.02,18.02,0,0,0,20,2Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M251.668,353.848a3.229,3.229,0,1,0-3.706,0,5.655,5.655,0,0,0-3.792,5.331.452.452,0,0,0,.9,0,4.744,4.744,0,0,1,9.487,0,.452.452,0,1,0,.9,0A6.266,6.266,0,0,0,251.668,353.848Zm-4.178-2.641a2.326,2.326,0,1,1,2.327,2.326,2.326,2.326,0,0,1-2.327-2.326Z",
    transform: "translate(695.959 50.197)",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107-2",
    "data-name": "Path 107",
    d: "M251.668,353.848a3.229,3.229,0,1,0-3.706,0,5.655,5.655,0,0,0-3.792,5.331.452.452,0,0,0,.9,0,4.744,4.744,0,0,1,9.487,0,.452.452,0,1,0,.9,0A6.266,6.266,0,0,0,251.668,353.848Zm-4.178-2.641a2.326,2.326,0,1,1,2.327,2.326,2.326,2.326,0,0,1-2.327-2.326Z",
    transform: "translate(709.182 63.531)",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107-3",
    "data-name": "Path 107",
    d: "M251.668,353.848a3.229,3.229,0,1,0-3.706,0,5.655,5.655,0,0,0-3.792,5.331.452.452,0,0,0,.9,0,4.744,4.744,0,0,1,9.487,0,.452.452,0,1,0,.9,0A6.266,6.266,0,0,0,251.668,353.848Zm-4.178-2.641a2.326,2.326,0,1,1,2.327,2.326,2.326,2.326,0,0,1-2.327-2.326Z",
    transform: "translate(722.641 50.091)",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107-4",
    "data-name": "Path 107",
    d: "M251.668,353.848a3.229,3.229,0,1,0-3.706,0,5.655,5.655,0,0,0-3.792,5.331.452.452,0,0,0,.9,0,4.744,4.744,0,0,1,9.487,0,.452.452,0,1,0,.9,0A6.266,6.266,0,0,0,251.668,353.848Zm-4.178-2.641a2.326,2.326,0,1,1,2.327,2.326,2.326,2.326,0,0,1-2.327-2.326Z",
    transform: "translate(709.182 37.515)",
    stroke: "#fff",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.1d581c8c8cefcbf1a61dba2ebfccdc73.svg";
export { ForwardRef as ReactComponent };